import type {
  SpecialtiesResponse,
  MatchingFilterResponse,
  MatchingFilterName,
} from '../models/derek'
import type { MatchingFilter } from '@/types/app'

export const parseSpecialtiesResponseToMatchingFilters = (
  specialtiesResponse: SpecialtiesResponse
): ReadonlyArray<MatchingFilter> =>
  specialtiesResponse.filter(isMatchingFilterResponse).map(item => {
    const { ...matchingFilter } = item
    return matchingFilter
  })

const matchingFilterNames: readonly MatchingFilterName[] = [
  '富裕層',
  '女性のみ',
]

// TODO: specialtyから「富裕層」「女性のみ」が取り除かれたら、この処理は削除する
export const isMatchingFilterResponse = (
  item: ValueOf<SpecialtiesResponse>
): item is MatchingFilterResponse =>
  (matchingFilterNames as unknown as string[]).includes(item.name)
